import EmptyRow from 'dashboard/layouts/FormLayout/EmptyRow';
import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import { Input } from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { Label } from 'design-system/components/Text';
import { useFormSecurely } from 'lib/security/reactHookForm';

export interface FormLoginSamlEmailProps {
  onSubmit: (data: FormLoginSamlEmailData) => void;
}

const FormLoginSamlEmail = ({ onSubmit }: FormLoginSamlEmailProps) => {
  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useFormSecurely<FormLoginSamlEmailData>();

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Label htmlFor='emailAddress' size='md' weight='bold'>
        Email address
      </Label>
      <Spacer height={1} />
      <Input
        {...register('emailAddress', {
          required: 'Please enter your email address',
        })}
        name='emailAddress'
        id='emailAddress'
        type='text'
        disabled={isSubmitting}
      />
      <EmptyRow />
      <Button type='submit' disabled={isSubmitting} isPending={isSubmitting}>
        Continue
      </Button>
    </Form>
  );
};

export interface FormLoginSamlEmailData {
  emailAddress: string;
}

export default FormLoginSamlEmail;
